<div [hidden]="!loading" class="spinner">
  <div class="sk-spinner sk-spinner-pulse"></div>
</div>
<app-table [rows]="rows" [columns]="columns" [batch]="false" [actions]="tableActions" (action)="onAction($event)" (cellClick)="onCellClick($event)">
</app-table>

<ng-template #deleteModalTpl let-dialogRef="dialogRef">
  <deletemodal [dialogRef]="dialogRef"></deletemodal>
</ng-template>

<ng-template #titleModalTpl let-dialogRef="dialogRef">
  <titlemodal [header]="'Edit the Word'" [titleLabel]="'Word'" [title]="currentTitle" [dialogRef]="dialogRef"></titlemodal>
</ng-template>
